import {useNavigate} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";

export const useMobileMenu = (toggleMobileMenu: () => void) => {
    const navigate = useNavigate();
    const {isAuthenticated} = useAuth0();

    const goToHomepage = () => {
        toggleMobileMenu();
        navigate("/");
    }

    const goToLogin = () => {
        toggleMobileMenu();
        navigate("/login?active=signIn");
    }

    const goToSignUp = () => {
        toggleMobileMenu()
        navigate("/login?active=signUp");
    }

    const goToPage = (path: string) => {
        toggleMobileMenu();
        if (isAuthenticated) navigate(`/${path}`);
        else {
            localStorage.setItem('navigation', `/${path}`);
            navigate('/login')
        }
    }
    return {
        goToHomepage,
        goToLogin,
        goToSignUp,
        goToPage,
    }
}